export default __webpack_public_path__ + "static/image2-85a5dec08fcab1d6b81697d4bd591c0f.png";